import React from 'react';
import { TextControl } from '../styles';
import { TextFilterField } from '../types';

export type TextFieldProps = {
  field: TextFilterField;
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  disabled?: boolean;
};

const TextField: React.FC<TextFieldProps> = ({
  field,
  value,
  onChange,
  onSearch,
  disabled
}) => {
  return (
    <TextControl
      type="text"
      id={`filter-${field.name}`}
      value={value || ''}
      placeholder={field.placeholder || 'Digite...'}
      disabled={disabled}
      onChange={e => onChange(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onSearch();
        }
      }}
    />
  );
};

export default TextField;
